/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ItemFolderWrapper_item$ref = any;
export type ItemFolderWrapperRefetchQueryVariables = {
    readonly itemId: string;
    readonly userId: string;
    readonly loadPortfolioData: boolean;
};
export type ItemFolderWrapperRefetchQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly " $fragmentRefs": ItemFolderWrapper_item$ref;
        } | null;
    } | null;
};
export type ItemFolderWrapperRefetchQuery = {
    readonly response: ItemFolderWrapperRefetchQueryResponse;
    readonly variables: ItemFolderWrapperRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "itemId",
            "variableName": "itemId"
        } as any),
        ({
            "kind": "Literal",
            "name": "pageType",
            "value": "PORTFOLIO"
        } as any)
    ], v2 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ItemFolderWrapperRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ItemFolderWrapper_item",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "loadPortfolioData",
                                            "variableName": "loadPortfolioData"
                                        },
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ItemFolderWrapperRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "serviceId",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v3 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "loadPortfolioData",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "folderPortfolioItems",
                                            "name": "portfolioItems",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "portfolioType",
                                                    "value": "FOLDER"
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "concreteType": "PortfolioItemV2",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "__typename",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ItemFolderWrapperRefetchQuery",
            "id": "app-buyer-misc/231.0.0-2019-09-03T19:01:08.630Z/ItemFolderWrapperRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'd14d694d06daa7e2ca3b885cff2b3a99';
export default node;
